/** @jsx jsx */
import React, { useRef } from 'react'
import { jsx } from 'theme-ui'
import {
  Pie,
  PieChart as PieChartContainer,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts'
import theme, { rem } from '@src/theme'
import { useOnScreen } from '@src/helpers/hooks/useOnScreen'

const COLORS = [
  theme.colors.purple,
  theme.colors.turquoise,
  theme.colors.red,
  theme.colors.pink,
  theme.colors.yellow,
  theme.colors.rainbowGreen,
  theme.colors.transBlue,
  theme.colors.transPink,
]

const formatPercent = (value) => {
  return `${Math.round(value * 100)}%`
}

function PieChart({ data }) {
  const ref = useRef(null)
  const isOnScreen = useOnScreen(ref, true)

  return (
    <div ref={ref} sx={{ maxWidth: '600px', mx: 'auto' }}>
      <ResponsiveContainer aspect={2}>
        <PieChartContainer
          style={{
            transition: 'opacity 300ms ease-in-out',
            opacity: isOnScreen ? 1 : 0
          }}
        >
          <Pie
            data={data}
            innerRadius="50%"
            outerRadius="100%"
            paddingAngle={0}
            dataKey="value"
            animationDuration={1600}
            isAnimationActive={isOnScreen}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
                stroke={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Legend
            dataKey="name"
            layout="vertical"
            align="right"
            verticalAlign="middle"
            iconType="circle"
            wrapperStyle={{ right: '-5px' }}
            formatter={(value, entry) => (
              <span sx={{ maxWidth: rem(160), verticalAlign: 'top', fontSize: rem(16), color: 'darkPurple', ml: 1, mb: 1, display: 'inline-block' }}>{formatPercent(entry.payload.value)} {value}</span>
            )}
          />
          <Tooltip
            contentStyle={{ border: 'none', borderRadius: 'calc(infinity * 1px)', background: theme.colors.darkPurple, padding: '6px 12px' }}
            itemStyle={{ display: 'flex', flexDirection: 'row-reverse', gap: '2px', color: 'white', fontSize: rem(16) }}
            formatter={formatPercent}
            separator=""
          />
        </PieChartContainer>
      </ResponsiveContainer>
    </div>
  )
}

export { PieChart }
